// extracted by mini-css-extract-plugin
module.exports = {"steps":"steps_steps__z9enB","avatar__components":"steps_avatar__components__WuCzy","content__steps":"steps_content__steps__Ai1Bs"};